export default __webpack_public_path__ + "static/media/w-product1.f9c3580c.jpg";